import React from "react";
import ListFilterPanel from "@/components/Shared/Filters/ListFilterPanel";
import { CompetenceItem } from "../../../models/Competence";
import {
	EMPTY_DEFINITION,
	FilterDefinition,
	SavedFilter,
	definitionsEqual,
	isEmptyDefinition,
} from "../../../models/ConsultantFilter";
import FilterBuilder, { FilterOptions } from "./FilterBuilder";

export type { FilterOptions } from "./FilterBuilder";

interface Props {
	isOpen: boolean;
	onClose: () => void;
	definition: FilterDefinition;
	onChange: (def: FilterDefinition) => void;
	options: FilterOptions;
	/** the org competence tree (branch → service → skills) for the picker */
	competenceTree: CompetenceItem[];
	savedFilters: SavedFilter[];
	/** org-defined filters, shown read-only in the manage view for context */
	orgFilters?: SavedFilter[];
	/** id of the saved filter currently being edited (the "base"), if any */
	activeSavedId?: string;
	onSaveNew: (name: string, def: FilterDefinition) => void;
	onUpdateSaved: (id: string, def: FilterDefinition) => void;
	onRenameSaved: (id: string, name: string) => void;
	onDeleteSaved: (id: string) => void;
	onReorderSaved: (ordered: SavedFilter[]) => void;
}

/**
 * The consultant list's filter drawer. A thin wrapper over the shared
 * `ListFilterPanel`, supplying the consultant `FilterBuilder` and the consultant
 * definition's empty/equality helpers.
 */
const ConsultantFilterPanel: React.FC<Props> = ({ options, competenceTree, ...rest }) => (
	<ListFilterPanel
		{...rest}
		isEmptyDefinition={isEmptyDefinition}
		definitionsEqual={definitionsEqual}
		emptyDefinition={EMPTY_DEFINITION}
		renderBuilder={(def, change) => (
			<FilterBuilder
				definition={def}
				onChange={change}
				options={options}
				competenceTree={competenceTree}
			/>
		)}
	/>
);

export default ConsultantFilterPanel;
